import { render } from "./OfferCeiling.vue?vue&type=template&id=1dc24764"
import script from "./OfferCeiling.vue?vue&type=script&lang=js"
export * from "./OfferCeiling.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__